import { render, staticRenderFns } from "./tabbed_graph_view.vue?vue&type=template&id=6bf36693&scoped=true&"
import script from "./tabbed_graph_view.vue?vue&type=script&lang=js&"
export * from "./tabbed_graph_view.vue?vue&type=script&lang=js&"
import style0 from "./tabbed_graph_view.vue?vue&type=style&index=0&id=6bf36693&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf36693",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTab,VTabItem,VTabs,VTooltip})
